import { useContext } from 'react';
import { TableFiltersContext } from '../Context/TableFilters.Context.es.js';

/**
 * Create table filters context hook.
 */ function useTableFilters() {
    return useContext(TableFiltersContext);
}

export { useTableFilters as default, useTableFilters };
//# sourceMappingURL=useTableFilters.es.js.map
